import React, { Dispatch, SetStateAction } from 'react';

import { roomIdSelector } from '@redux/room/selectors';
import { songsMetadataSelector } from '@redux/songStorage';
import { useSelector } from 'react-redux';
import { Song } from 'src/@types/api-types';

import Mp3KbpPlayer from 'components/b2c/Mp3KbpPlayer';
import Mp4Player from 'components/shared/VideoPlayer';
import { SCOPE } from 'shared-types/constants';
import { PlayerSongDetails } from 'shared-types/player-event';
import { PLAYER_TYPE, VideoMetadata } from 'shared-types/video-metadata';

import { waitingListDownloadInstrumental } from './VideoPlayer.utils';

interface VideoPlayerProps {
  song: { id: string };
  activeVideoElement: HTMLVideoElement | null;
  songDetails?: Song;
  setInstrumentalVideoElement: Dispatch<SetStateAction<HTMLVideoElement | null>>;
  setVocalGuideVideoElement?: Dispatch<SetStateAction<HTMLVideoElement | null>>;
  videoMetadata?: VideoMetadata;
  controls: boolean;
  handlePlay: () => void;
  scope: SCOPE;
  currentSongDetails?: PlayerSongDetails | null;
  nextSongDetails?: PlayerSongDetails | null;
  isStorageActivated: boolean;
}

const VideoPlayer: React.FunctionComponent<VideoPlayerProps> = ({
  song,
  activeVideoElement,
  songDetails,
  setInstrumentalVideoElement,
  setVocalGuideVideoElement,
  videoMetadata,
  controls,
  handlePlay,
  scope,
  currentSongDetails,
  nextSongDetails,
  isStorageActivated,
}) => {
  const waitingListMetadata = useSelector(songsMetadataSelector);
  const roomId = useSelector(roomIdSelector);
  return !videoMetadata || videoMetadata.playerType === PLAYER_TYPE.MP3_KBP ? (
    <Mp3KbpPlayer
      song={song}
      activeVideoElement={activeVideoElement}
      songDetails={songDetails}
      setInstrumentalVideoElement={setInstrumentalVideoElement}
      setVocalGuideVideoElement={setVocalGuideVideoElement}
      controls={controls}
      handlePlay={handlePlay}
      scope={scope}
      currentSongDetails={currentSongDetails}
      nextSongDetails={nextSongDetails}
      waitingListMetadata={waitingListMetadata}
      isStorageActivated={isStorageActivated}
    />
  ) : (
    <Mp4Player
      setVideoElement={setInstrumentalVideoElement}
      licenseToken={videoMetadata.licenseToken}
      videoUrl={videoMetadata.videoUrl}
      controls={controls}
      onVideoLoadEnd={handlePlay}
      waitingListDownloadMetadata={waitingListDownloadInstrumental(waitingListMetadata)}
      isStorageActivated={isStorageActivated}
      roomId={roomId}
    />
  );
};

export default VideoPlayer;
